import React from 'react';
import { FileText, File } from 'lucide-react';
import { FillTemplateKey } from './types';

interface DocumentPreviewProps {
    templateKeys: FillTemplateKey[];
    originalFilename?: string;
}

const DocumentPreview: React.FC<DocumentPreviewProps> = ({
    templateKeys,
    originalFilename,
}) => {
    const filledKeys = templateKeys.filter((key) => key.value.trim() !== '');
    const requiredMissingKeys = templateKeys.filter(
        (key) => !key.value.trim() && key.is_required
    );
    const optionalEmptyKeys = templateKeys.filter(
        (key) => !key.value.trim() && !key.is_required
    );

    return (
        <div className="bg-gray-50 rounded-lg p-4 min-h-[300px]">
            <div className="flex items-center mb-4">
                <File className="h-5 w-5 text-gray-400 mr-2" />
                <span className="text-sm text-gray-600">{originalFilename}</span>
            </div>
            <div className="text-sm space-y-3">
                <div className="bg-white border rounded-lg p-4 min-h-[200px]">
                    <div className="flex items-center mb-3">
                        <FileText className="h-4 w-4 text-blue-600 mr-2" />
                        <span className="font-medium text-gray-900">Döküman Önizleme</span>
                    </div>

                    {filledKeys.length > 0 ? (
                        <div className="space-y-2">
                            <div className="text-xs text-gray-500 mb-2">
                                Template'deki alanlar şu değerlerle değiştirilecek:
                            </div>
                            {filledKeys.map((key, index) => (
                                <div
                                    key={index}
                                    className="bg-gray-50 rounded p-2 border-l-2 border-blue-500"
                                >
                                    <div className="flex items-start justify-between">
                                        <div className="flex-1">
                                            <code className="text-xs bg-gray-200 px-1 rounded text-gray-700">
                                                {`{{${key.key_name}}}`}
                                            </code>
                                            <span className="mx-2 text-gray-400">→</span>
                                            <span className="text-blue-600 font-medium">{key.value}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {requiredMissingKeys.length > 0 && (
                                <div className="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded">
                                    <div className="flex items-center">
                                        <span className="text-yellow-600 text-xs font-medium">
                                            ⚠️ Gerekli alanlar eksik:
                                        </span>
                                    </div>
                                    <div className="mt-1 text-xs text-yellow-700">
                                        {requiredMissingKeys.map((key) => key.key_name).join(', ')}
                                    </div>
                                </div>
                            )}

                            {optionalEmptyKeys.length > 0 && (
                                <div className="mt-2 text-xs text-gray-500">
                                    Boş bırakılan opsiyonel alanlar:{' '}
                                    {optionalEmptyKeys.map((key) => key.key_name).join(', ')}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-center text-gray-400 py-8">
                            <div className="mb-2">📄</div>
                            <p className="text-sm">Alanları doldurun</p>
                            <p className="text-xs">Önizleme burada görünecek</p>
                        </div>
                    )}
                </div>

                <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 space-y-1">
                        <div className="flex justify-between">
                            <span>Toplam Alan:</span>
                            <span className="font-medium">{templateKeys.length}</span>
                        </div>
                        <div className="flex justify-between">
                            <span>Doldurulan:</span>
                            <span className="font-medium text-green-600">
                                {filledKeys.length}
                            </span>
                        </div>
                        <div className="flex justify-between">
                            <span>Kalan:</span>
                            <span className="font-medium text-orange-600">
                                {templateKeys.length - filledKeys.length}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentPreview;
